import { http, ep } from '../../client/http';

export const boardRepo = {
  get: async () => {
    const res = await http.get(ep('board/list'), {
      params: { status: true }
    });
    return res.data.data;
  }
};
